import {parsePhoneNumberFromString} from 'libphonenumber-js/min';

export function employeeMenu(requested,manager=false){
 if(requested==='benim')return 'evraklar';
 return ['profilAyarlari','evraklar','egitimler','sertifikalar','sinavlar','anketlerim','ekipEgitimDurumu','magazaIlanlarim','paylasilanAdaylar','mail'].includes(requested)?requested:manager?'ekipEgitimDurumu':'egitimler';
}
function parse(value){
 let text=String(value??'').trim().replace(/^00/,'+');
 if(/^90\d{10}$/.test(text.replace(/[\s().-]/g,'')))text='+'+text;
 return parsePhoneNumberFromString(text,{defaultCountry:'TR',extract:false});
}
export function profilePhone(value){
 const parsed=parse(value);
 // Do not hide/cut an unfamiliar legacy number or invent a country for it.
 return parsed?.isPossible()?parsed.formatInternational():String(value??'').trim();
}
export function contactPhone(value){
 const parsed=parse(value);
 if(!parsed?.isPossible()||(parsed.countryCallingCode==='90'&&!/^5\d{9}$/.test(parsed.nationalNumber)))return null;
 return parsed.number;
}
export function contactError(error){
 const code=error?.response?.data?.code;
 const keys={phoneInvalid:'phoneInvalid',phoneInUse:'phoneInUseMessage',verifiedEmailRequired:'contactVerifiedEmailRequired',verifiedEmailChanged:'contactEmailChanged',contactRequestMissing:'contactRequestMissing',contactAttemptsExceeded:'contactAttemptsExceeded',contactInvalidCode:'contactInvalidCodeMessage',contactCooldown:'contactCooldown'};
 if(keys[code])return keys[code];
 const message=typeof error?.response?.data==='string'?error.response.data:error?.response?.data?.message;
 const legacy={'Bu e-posta adresi başka bir kullanıcıda kayıtlı.':'emailExists','Bu telefon numarası başka bir kullanıcıda kayıtlı.':'phoneInUseMessage','Geçerli bir Türkiye GSM numarası giriniz.':'phoneInvalid','Kod hatalı.':'contactInvalidCodeMessage','Geçerli bir iletişim değişikliği talebi bulunamadı. Lütfen yeniden kod isteyin.':'contactRequestMissing'};
 if(legacy[message])return legacy[message];
 if(error?.response?.status===429)return 'contactCooldown';
 return 'contactResultUnknown';
}
